import { Button, Col, Divider, Form, Row, Space, Spin, Table } from 'antd';
import { observer } from 'mobx-react';
import { accommodationRequest } from '../../../../request/AuthRequest';
import InputComponent from '../../../../component/InputComponent';
import { useEffect, useState } from 'react';
import useStore from '../../../../store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import DeleteRoomCategoryComponent from './DeleteRoomCategoryComponent';
import Message from '../../../../config/Message';
import { Notification } from '../../../../config/Global';
import RoomCategoryImageApproveModal from './RoomCategoryImageApprove';

const RoomCategoryForm = observer((props) => {
	const { handleChange, onFinish, id, form, initialValues, disable } = props;
	const [roomAmenityLoading, setRoomAmenityLoading] = useState(true);
	const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
	const [roomLoading, setRoomLoading] = useState(true);
	const { ACCOMMODATION } = useStore();
	const [roomCategoryImageModal, setRoomCategoryImageModal] = useState(false);

	const {
		AUTH: {
			lookupKeyList,
			amenityList,
			getAllByLookupKeyList,
			getAmenityList,
		},
		ACCOMMODATION: { roomcategorybyproperty, roomCategoryEditData },
	} = useStore();

	const showDeleteModal = (data) => {
		setIsDeleteModalVisible(data);
	};

	const handleDeleteModalClose = () => {
		setIsDeleteModalVisible(false);
	};

	const openImage = (data) => {
		setRoomCategoryImageModal(data.id);
	};

	const closeImageModal = () => {
		setRoomCategoryImageModal(false);
	};

	useEffect(() => {
		if (roomCategoryEditData && isDeleteModalVisible) {
			if (roomCategoryEditData.id === isDeleteModalVisible.id) {
				ACCOMMODATION.roomCategoryEditData = null;
			}
		}
	}, [roomCategoryEditData, isDeleteModalVisible]);

	useEffect(() => {
		if (roomCategoryEditData) {
			getAllByLookupKeyList('lookupKey=ROOMTYPE&isAdmin=false').then(() => {
			form.setFieldsValue({
				roomCategoryAddModels: [
					{
						roomType: Number(roomCategoryEditData.roomType),
						roomTitle: roomCategoryEditData.roomTitle,
						noofBed: roomCategoryEditData.noofBed,
						additionalBedCapacity:
							roomCategoryEditData.additionalBedCapacity,
						noofBathroom: roomCategoryEditData.noofBathroom,
						maxGuest: roomCategoryEditData.maxGuest,
						noOfRooms: roomCategoryEditData.noOfRooms,
						roomSize: roomCategoryEditData.roomSize,
						// eAmenityId:
						// 	roomCategoryEditData.roomCategoryAmenityViewModel?.map(
						// 		(a) => a.amenityName
						// 	) || [],
						eAmenityId:
							roomCategoryEditData.roomCategoryAmenityViewModel !=
							null
								? roomCategoryEditData.roomCategoryAmenityViewModel
										.filter((_x) => _x.eAmenityId)
										.map((_x) => _x.eAmenityId)
								: null,
					},
				],
			});
		});
		} else {
			form.resetFields();
		}
	}, [roomCategoryEditData]);

	const UpdateRoomCategorySubmit = async (data) => {
		const updatedValues = form.getFieldsValue();
		const finalmodel = {
			...roomCategoryEditData,
			...updatedValues.roomCategoryAddModels[0], // Update with new values
		};
		//room category amenity
		const amenityRoomcategoryMap = new Map(
			roomCategoryEditData?.roomCategoryAmenityViewModel.map((item) => [
				item.eAmenityId,
				item,
			])
		);

		const tempRoomCategoryArray = finalmodel.eAmenityId.map(
			(amenity) =>
				amenityRoomcategoryMap.get(amenity) || {
					eAmenityId: amenity,
				}
		);

		const tempArrayRoomCategorySet = new Set(finalmodel.eAmenityId);
		const deletedRoomCategoryAmenity =
			finalmodel.roomCategoryAmenityViewModel
				.filter(
					(item) => !tempArrayRoomCategorySet.has(item.eAmenityId)
				)
				.map((item) => ({ ...item, isActive: false }));

		// roomCategoryEditData['eAmenityId'] = [
		// 	...tempRoomCategoryArray,
		// 	...deletedRoomCategoryAmenity,
		// ];

		let roomPayload = {
			id: finalmodel.id,
			versionNo: finalmodel.versionNo,
			isActive: finalmodel.isActive,
			ePropertyId: finalmodel.ePropertyId,
			roomTitle: finalmodel.roomTitle,
			roomType: finalmodel.roomType,
			noofBed: finalmodel.noofBed,
			additionalBedCapacity: finalmodel.additionalBedCapacity,
			noofBathroom: finalmodel.noofBathroom,
			maxGuest: finalmodel.maxGuest,
			noOfRooms: finalmodel.noOfRooms,
			roomSize: finalmodel.roomSize,
			roomCategoryAmenityUpdateModelList: (finalmodel['eAmenityId'] = [
				...tempRoomCategoryArray,
				...deletedRoomCategoryAmenity,
			]),
		};
		ACCOMMODATION.EditRoomCategory({ ...roomPayload })
			.then((data) => {
				if (typeof data !== 'string') {
					Notification.success({
						message: Message().CRUD.UPDATE('Room Category Detail'),
					});
					ACCOMMODATION.getRoomCategoryByProperty(
						finalmodel.ePropertyId
					);
					form.resetFields();
					ACCOMMODATION.roomCategoryEditData = null;
				} else {
					Notification.error({
						message: data,
					});
				}
			})
			.catch((e) => {});
		// .finally(() => setSaving(false));
	};

	const columns = [
		{
			title: 'Room Type',
			dataIndex: 'roomTypeName',
			key: 'roomTypeName',
		},
		{
			title: 'Room Title',
			dataIndex: 'roomTitle',
			key: 'roomTitle',
		},
		{
			title: 'Total Bed',
			dataIndex: 'noofBed',
			key: 'noofBed',
		},
		{
			title: 'Additional Bed Capacity',
			dataIndex: 'additionalBedCapacity',
			key: 'additionalBedCapacity',
		},
		{
			title: 'Total Bathroom',
			dataIndex: 'noofBathroom',
			key: 'noofBathroom',
		},
		{
			title: 'Max Guest',
			dataIndex: 'maxGuest',
			key: 'maxGuest',
		},
		{
			title: 'Total Room',
			dataIndex: 'noOfRooms',
			key: 'noOfRooms',
		},
		{
			title: 'Room Size',
			dataIndex: 'roomSize',
			key: 'roomSize',
		},
		{
			title: 'Amenities',
			dataIndex: 'amenities',
			key: 'amenities',
			render: (text) => text,
		},
		{
			title: 'Image Approved',
			dataIndex: 'imageApproved',
			key: 'imageApproved',
			render: (text, rec) => <p>{text ? 'True' : 'False'}</p>,
		},
		{
			title: 'Action',
			key: 'action',
			render: (text, props, index) => (
				<Space size="middle">
					{/* <Button
						type="primary"
						className="addBtn"
						onClick={() => {
							ACCOMMODATION.roomCategoryEditData =
								roomcategorybyproperty[index];
						}}
					>
						Edit
					</Button> */}
					<Button
						type="primary"
						className="addBtn"
						onClick={() => showDeleteModal(props)}
					>
						Delete
					</Button>
					<Button
						type="text"
						title={
							props.imageApproved
								? 'Approved'
								: 'Pending Approval'
						}
						//disabled={props.imageApproved}
						className="imgIcon"
						onClick={() => {
							ACCOMMODATION.ReadRoomCategoryImagedetail({
								tableName: 'roomcategory',
								roomCategoryID: props.id,
							});
							openImage(props);
						}}
					>
						<FontAwesomeIcon
							color={props.imageApproved ? '#ff6f00' : '#000'}
							icon={faImage}
						/>
					</Button>
				</Space>
			),
		},
	];

	const dataSource =
		(roomcategorybyproperty &&
			roomcategorybyproperty.length &&
			roomcategorybyproperty?.map((item) => ({
				id: item.id,
				roomType: item.roomType,
				roomTypeName: item.roomTypeName,
				roomTitle: item.roomTitle,
				noofBed: item.noofBed,
				additionalBedCapacity: item.additionalBedCapacity,
				noofBathroom: item.noofBathroom,
				maxGuest: item.maxGuest,
				noOfRooms: item.noOfRooms,
				versionNo: item.versionNo,
				roomSize: item.roomSize,
				imageApproved: item.imageApproved,
				amenities:
					item.roomCategoryAmenityViewModel &&
					item.roomCategoryAmenityViewModel.length
						? item.roomCategoryAmenityViewModel
								.map((a) => a.amenityName)
								.join(', ')
						: 'No Amenity',
			}))) ||
		[];

	useEffect(() => {}, [roomCategoryEditData]);

	return (
		<>
			<Form
				id={id}
				layout="vertical"
				form={form}
				onFinish={onFinish}
				autoComplete="off"
				onChange={handleChange}
				initialValues={initialValues}
			>
				<Row gutter={24}>
					<Col span={24}>
						<Form.List name="roomCategoryAddModels">
							{(fields, { add, remove }) => {
								return (
									<Row>
										{fields.map(
											({ key, name, ...restField }) => (
												<Col span={24} key={key}>
													<Row
														gutter={24}
														align={'bottom'}
													>
														<Col span={20}>
															<Row gutter={24}>
																<Col span={5}>
																	<InputComponent
																		required
																		type="select"
																		showSearch={
																			true
																		}
																		name={[
																			name,
																			'roomType',
																		]}
																		label="Select Room Type"
																		placeholder="Select Room Type"
																		onFocus={() =>
																			roomLoading &&
																			getAllByLookupKeyList(
																				'lookupKey=ROOMTYPE&isAdmin=false'
																			).then(
																				() =>
																					setRoomLoading(
																						false
																					)
																			)
																		}
																		onChange={
																			handleChange
																		}
																		options={{
																			values:
																				lookupKeyList &&
																				lookupKeyList.length
																					? lookupKeyList
																					: roomCategoryEditData && [
																							{
																								lookupIntValue:
																								Number (roomCategoryEditData.roomType),
																								lookupValue:
																									roomCategoryEditData.roomTypeName,
																							},
																						],
																			value_key:
																				'lookupIntValue',
																			text_key:
																				'lookupValue',
																		}}
																		notFoundContent={
																			roomLoading ? (
																				<Spin size="small" />
																			) : (
																				'No Data Found'
																			)
																		}
																		allowClear
																		rules={
																			accommodationRequest.roomType
																		}
																	/>
																</Col>
																<Col span={5}>
																	<InputComponent
																		required
																		name={[
																			name,
																			'roomTitle',
																		]}
																		label="Room Title"
																		placeholder="Enter Room Title"
																		onChange={
																			handleChange
																		}
																		rules={
																			accommodationRequest.roomTitle
																		}
																	/>
																</Col>
																<Col span={4}>
																	<InputComponent
																		required
																		name={[
																			name,
																			'noofBed',
																		]}
																		label="Total Bed"
																		placeholder="Enter Total Bed"
																		onChange={
																			handleChange
																		}
																		rules={
																			accommodationRequest.noofBed
																		}
																	/>
																</Col>
																<Col span={6}>
																	<InputComponent
																		required
																		name={[
																			name,
																			'additionalBedCapacity',
																		]}
																		label="Additional Bed Capacity"
																		placeholder="Enter Additional Bed Capacity"
																		onChange={
																			handleChange
																		}
																		rules={
																			accommodationRequest.additionalBedCapacity
																		}
																	/>
																</Col>
																<Col span={4}>
																	<InputComponent
																		required
																		name={[
																			name,
																			'noofBathroom',
																		]}
																		label="Total Bathroom"
																		placeholder="Enter Total Bathroom"
																		onChange={
																			handleChange
																		}
																		rules={
																			accommodationRequest.noofBathroom
																		}
																	/>
																</Col>
																<Col span={6}>
																	<InputComponent
																		required
																		name={[
																			name,
																			'maxGuest',
																		]}
																		label="Max Guest"
																		placeholder="Enter Max Guest"
																		onChange={
																			handleChange
																		}
																		rules={
																			accommodationRequest.maxGuest
																		}
																	/>
																</Col>
																<Col span={6}>
																	<InputComponent
																		required
																		name={[
																			name,
																			'noOfRooms',
																		]}
																		label="Total Room"
																		placeholder="Enter Total Room"
																		onChange={
																			handleChange
																		}
																		rules={
																			accommodationRequest.noofRoom
																		}
																	/>
																</Col>
																<Col span={6}>
																	<InputComponent
																		// required
																		name={[
																			name,
																			'roomSize',
																		]}
																		label="Room Size (e.g. 200 sq. ft)"
																		placeholder="Enter Room Size (e.g. 200 sq. ft)"
																		onChange={
																			handleChange
																		}
																		rules={
																			accommodationRequest.roomSize
																		}
																	/>
																</Col>
																<Col span={6}>
																	<InputComponent
																		required
																		type="select"
																		mode="multiple"
																		showSearch={
																			true
																		}
																		name={[
																			name,
																			'eAmenityId',
																		]}
																		label="Select Amenity"
																		placeholder="Select Amenity"
																		onFocus={() => {
																			roomAmenityLoading &&
																				getAmenityList(
																					'3'
																				).then(
																					() =>
																						setRoomAmenityLoading(
																							false
																						)
																				);
																		}}
																		notFoundContent={
																			roomAmenityLoading ? (
																				<Spin size="small" />
																			) : (
																				'No Data Found'
																			)
																		}
																		options={{
																			values:
																				(amenityList.length &&
																					amenityList) ||
																				(roomCategoryEditData &&
																					roomCategoryEditData.roomCategoryAmenityViewModel &&
																					roomCategoryEditData
																						.roomCategoryAmenityViewModel
																						.length &&
																					roomCategoryEditData.roomCategoryAmenityViewModel),
																			value_key:
																				'eAmenityId',
																			text_key:
																				'amenityName',
																		}}
																		onChange={
																			handleChange
																		}
																		rules={
																			accommodationRequest.amenity
																		}
																	/>
																</Col>
															</Row>
														</Col>
														<Col span={4}>
															{!roomCategoryEditData && (
																<Button
																	danger
																	style={{
																		marginBottom:
																			'12px',
																	}}
																	onClick={() => {
																		remove(
																			name
																		);
																		handleChange();
																	}}
																>
																	<FontAwesomeIcon
																		icon={
																			faMinus
																		}
																	/>
																</Button>
															)}
														</Col>
													</Row>
												</Col>
											)
										)}
										<Divider align="center">
											<Form.Item
												style={{
													marginBottom: '0',
												}}
											>
												<Button
													type="primary"
													onClick={() => {
														if (
															roomCategoryEditData ===
															null
														) {
															add();
															handleChange();
														} else {
															UpdateRoomCategorySubmit();
														}
													}}
													icon={
														<FontAwesomeIcon
															icon={faPlus}
														/>
													}
												>
													{roomCategoryEditData ===
													null
														? 'Add Room Category'
														: 'Update'}
												</Button>
											</Form.Item>
										</Divider>
									</Row>
								);
							}}
						</Form.List>
					</Col>
				</Row>
			</Form>
			<Table
				dataSource={dataSource}
				columns={columns}
				pagination={false}
			/>
			<DeleteRoomCategoryComponent
				visible={isDeleteModalVisible}
				onClose={handleDeleteModalClose}
				propertyId={props}
			/>
			<RoomCategoryImageApproveModal
				visible={roomCategoryImageModal}
				onClose={closeImageModal}
				roomCategoryId={props}
			/>
		</>
	);
});
export default RoomCategoryForm;
